import React, { Component } from 'react';
import '../../Modal.css';
import { connect } from 'react-redux';
import { updateSelectedWaiver } from '../../../../actions/adminActions/waiversActions';
import { waivers } from '../../../../apis/backend';

class EditModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: this.props.selectedWaiver.id,
      name: this.props.selectedWaiver.name,
      validForDays: this.props.selectedWaiver.validForDays
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    console.log('Selected waiver:', this.props.selectedWaiver);
    if (prevProps.selectedWaiver !== this.props.selectedWaiver && this.props.selectedWaiver !== 0) {
      const waiver = this.props.waivers.find((obj) => obj.id === this.props.selectedWaiver);
      if (waiver) {
        this.setState({
          name: waiver.name,
          validForDays: waiver.validForDays
        });
      }
    }
  }

  async loadWaiver() {
    try {
      const response = await waivers.get('/findOne', {
        headers: { authorization: this.props.employeeToken },
        params: {
          id: 2
        }
      });
      if (response.data) {
        this.setState({
          name: response.data.name,
          validForDays: response.data.validForDays
        });
      }
    } catch (err) {
      console.log('Failed to load waiver:', err);
    }
  }

  clearState() {
    this.setState({
      id: '',
      name: this.props.selectedWaiver.name,
      validForDays: this.props.selectedWaiver.validForDays
    });
  }

  async waiverRequest() {
    try {
      await waivers
        .patch(
          `/${this.props.selectedWaiver}`,
          {
            name: this.state.name,
            validForDays: this.state.validForDays
          },
          { headers: { authorization: this.props.employeeToken } }
        )
        .then(this.clearState())
        .catch((response) => {
          console.log(response);
          alert('Sorry, an error occurred. Please check your entries.');
        });
    } catch (err) {
      console.log('Request Failed.');
    }
  }

  render() {
    return (
      <div id="exampleModal" className="modal fade" style={{ overflow: 'scroll' }}>
        <div className="modal-dialog modal-dialog-centered lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Update Waiver</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="input-group input-group-sm mb-3">
                <div className="input-group-prepend">
                  <span className="input-group-text" id="inputGroup-sizing-sm">
                    Waiver Name
                  </span>
                </div>
                <input
                  type="text"
                  className="form-control"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  value={this.state.name}
                  onChange={(e) => this.setState({ name: e.target.value })}
                />
              </div>
              {
                // Liability waiver (id=1) cannot be edited, so do not show valid for days input if selected
              }
              {this.props.selectedWaiver != 1 && (
                <div className="input-group input-group-sm mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="inputGroup-sizing-sm">
                      Valid For
                    </span>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    value={this.state.validForDays}
                    placeholder="Number of Days"
                    onChange={(e) => this.setState({ validForDays: e.target.value })}
                  />
                </div>
              )}
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
                onClick={() => this.clearState()}
              >
                Cancel
              </button>
              {
                // Liability waiver (id=1) cannot be edited, so do not show save changes button if selected
              }
              {this.props.selectedWaiver != 1 && (
                <button
                  type="button"
                  className="btn btn-dark"
                  data-dismiss="modal"
                  onClick={() => {
                    this.waiverRequest();
                  }}
                  disabled={
                    !this.state.name || !this.state.validForDays || this.props.selectedWaiver === 1
                  }
                >
                  Save changes
                </button>
              )}
              {
                // Show message indicating that liability waiver cannot be edited
              }
              {this.props.selectedWaiver === 1 && (
                <p style={{ color: 'red', marginLeft: '10px' }}>
                  * Liability waiver cannot be edited.
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  waivers: state.admin.admin.waivers,
  selectedWaiver: state.admin.waivers.selectedWaiver,
  employeeToken: state.auth.employeeToken
});

export default connect(mapStateToProps, {
  updateSelectedWaiver
})(EditModal);
